<template>
   <Card shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2'}" :padding="0">
      <div class="resources-item-header" :style="{padding: '10px 10px 8px'}" @click="viewResource(item.id)">
         <!-- <Icon v-if="profileInfo.user_type !== 'guest'" type="chevron-right" style="float:right;line-height:40px"></Icon> -->
         <a><Avatar shape="square" size="large" :src="previewImage(item)" :style="{float:'left', marginRight: '10px'}" /></a>
         <p class="truncate" style="padding-right:20px">
            <b>{{item.title}}</b>
         </p>
        <small style="color:#aaa;width: 100%;">
          By: <b>{{item.submitted.display_name}}</b> &nbsp;
          <span style="float:right;color:#2d8cf0;vertical-align:middle;margin-top:-15px;margin-right:10px;font-size: 20px" v-if="profileInfo.user_type !== 'guest' && item.subscribed">
            <i class="fas fa-check-circle"></i></span>
        </small>
      </div>
   </Card>
</template>

<script>
export default {
  name: 'ResourceListItemComponent',
  props: {
    item: {
      required: true
    }
  },
  computed: {
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    }
  },
  methods: {
    previewImage (item) {
      return item.thumbnail_photo[0]['small']
    },
    viewResource (id) {
      this.$router.push({
        path: '/resources/' + id
      })
    }
  }
}
</script>
